import { TFunction } from 'i18next';
import applePlatformImage from 'public/product-locales/apple-business.webp';
import fbPlatformImage from 'public/product-locales/fb-business.webp';
import googlePlatformImage from 'public/product-locales/google-business.webp';
import locationsPreviewImage from 'public/product-locales/locations-preview.webp';
import analyticsImg from 'public/product-locales/platforms-analytics.webp';
import syncPlatformsImage from 'public/product-locales/platforms-sync.webp';

const blockImages = [
  syncPlatformsImage,
  googlePlatformImage,
  applePlatformImage,
  fbPlatformImage,
  analyticsImg,
];

export const getMainBlockData = (t: TFunction) => ({
  description: t('productPages.locals.mainBlock.description'),
  heading: t('productPages.locals.mainBlock.heading'),
  image: locationsPreviewImage,
});

export const getBlocksData = (t: TFunction) => {
  const blocks = t('productPages.locals.blocks', { returnObjects: true }) as Array<{
    heading: string;
    description: string;
  }>;

  return blocks.map((block, index) => ({
    ...block,
    image: blockImages[index]!,
  }));
};

// Deprecated: Legacy exports for backward compatibility
export const mainBlockData = {
  description:
    'Enhance your business profiles on leading platforms like Google, Apple Maps, Facebook, and Bing to attract more customers and top the local search results',
  heading: 'Elevate Your Business Above the Local Crowd',
  image: locationsPreviewImage,
};

export const blocksData = [
  {
    heading: 'Efficiently manage your business information',
    description:
      'Seamlessly create and update vital business details for all your locations from a single, centralized dashboard. Oversee addresses, operating hours, services offered, media galleries, and over 50 additional data fields to ensure your business information is accurate and consistent everywhere your customers find you',
    image: syncPlatformsImage,
  },
  {
    heading: 'Shine in Google search results',
    description:
      'Since over 85% of online traffic comes from Google, maximizing your visibility there is crucial. Enhance your local search rankings by building precise and appealing Google Business Profiles. Showcase customer reviews on your Google Knowledge Panel, engage with visitors through Q&A, highlight your services, share updates via Google Posts, and provide easy booking links to attract more customers',
    image: googlePlatformImage,
  },
  {
    heading: 'Get noticed by Apple users',
    description:
      'Create engaging and informative Apple Maps listings to ensure your business stands out within the Apple ecosystem. Reach customers using Apple Maps, Siri, Messages, Wallet, and more by providing detailed and attractive Place Cards that encourage them to choose your business',
    image: applePlatformImage,
  },
  {
    heading: 'Connect with customers on Facebook',
    description:
      'Build compelling Facebook Business Pages to engage with the vast community of Facebook users. Share updates, highlight customer recommendations, and interact directly through Messenger. Use social posts to keep your audience informed and interested, turning visitors into loyal customers',
    image: fbPlatformImage,
  },
  {
    heading: 'Maintain accuracy with proactive monitoring',
    description:
      'Keep your business information precise across all directories and locations. Our error reporting dashboard provides proactive alerts about any inconsistencies or issues with your listings across various sites. Stay informed and correct errors swiftly to maintain a trustworthy online presence',
    image: analyticsImg,
  },
];
